import { useEventCache } from 'hooks/useLRQ/useEventCache';
import ResizePanel from 'react-resize-panel-ts';
import { useRecoilState, useRecoilValue } from 'recoil';

import { QueryType } from 'common/graphqlTypes';
import { getRequestIds } from 'common/util/lrqRequest';
import { selectedTokenState } from 'components/common/Managers/RouteStateManager.state';
import { getSchemaState, logDetailsRendererState } from 'components/common/Managers/ViewStateManager.state';
import { selectedLogEntryState } from 'api/apolloClient.state';
import {
  logResultsStatus,
  paginatedLogRequestsState,
  pinLogDetailsState,
  useProgressiveStateManagement,
} from 'components/search/SearchLogsPage/SearchStateManager.state';
import { logToInspectState } from 'components/search/SearchLogsPage/LogResultsContainer.hooks';

function LogDetailsContainer(): JSX.Element | null {

  const [ selectedToken, setSelectedToken ] = useRecoilState(selectedTokenState);
  const logEntryRequests = useRecoilValue(paginatedLogRequestsState);
  const eventCacheIds = getRequestIds(logEntryRequests, QueryType.LOG);
  const [ pinLogDetails, setPinLogDetails ] = useRecoilState(pinLogDetailsState);
  const logEntry = useRecoilValue(selectedLogEntryState);
  const logToInspect = useRecoilValue(logToInspectState);
  const getSchema = useRecoilValue(getSchemaState);

  let eventCache = useEventCache(eventCacheIds, true);
  const returnPreviousCache = eventCache.results?.length === 0 || false;
  eventCache = useProgressiveStateManagement(eventCache, eventCacheIds, logResultsStatus, returnPreviousCache);
  const { paginatedData: { currentIds } } = eventCache;

  const LogDetailsRenderer = useRecoilValue(logDetailsRendererState);

  if (!pinLogDetails || !selectedToken || !(currentIds?.includes(selectedToken) || !!logToInspect)) {
    return null;
  }

  return (
    <ResizePanel
      direction="w"
      handleClass='SearchLogsResultsArea__ResizeCustomHandle'
      containerClass="SearchLogsResultsArea__ResizeContainer">
      <div className="SearchLogsResultsArea__LogDetailsContainer">
        <LogDetailsRenderer
          logEntry={logToInspect || logEntry}
          continuationToken={selectedToken}
          onClose={() => setSelectedToken('')}
          onTogglePinned={() => setPinLogDetails(pinLogDetails => !pinLogDetails)}
          isPinned={pinLogDetails}
          schema={getSchema(logToInspect || logEntry)}
        />
      </div>
    </ResizePanel>
  );
}

export default LogDetailsContainer;
